import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

import { useTypedProjectCostContext } from '../useTypedProjectCostContext';
import type { CompanyStats } from '../types';
import CompaniesTable from '../components/tables/CompaniesTable';
import { formatPercent } from '../utils';

const CompanySummaryPage: React.FC = () => {
  const { companyId } = useParams();
  const numericCompanyId = Number(companyId);
  const { companyStatsList } = useTypedProjectCostContext<{
    companyStatsList: CompanyStats[];
  }>();

  const stats = companyStatsList.find((item) => item.companyId === numericCompanyId);

  return (
    <>
      {stats && (
        <Row className="g-3 mb-3">
          <Col md={3}>
            <Card className="cost-kpi">
              <Card.Body>
                <div>Colaboradores</div>
                <strong>{stats.collaboratorsCount}</strong>
              </Card.Body>
            </Card>
          </Col>
          <Col md={3}>
            <Card className="cost-kpi">
              <Card.Body>
                <div>Regras empresa+função</div>
                <strong>{stats.companyRoleRatesCount}</strong>
              </Card.Body>
            </Card>
          </Col>
          <Col md={3}>
            <Card className="cost-kpi">
              <Card.Body>
                <div>Taxas temporais</div>
                <strong>{stats.collaboratorRatesCount}</strong>
              </Card.Body>
            </Card>
          </Col>
          <Col md={3}>
            <Card className="cost-kpi">
              <Card.Body>
                <div>Mapeamento Jira</div>
                <strong>{formatPercent(stats.mappingPercent)}</strong>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}
      <CompaniesTable companyId={numericCompanyId} />
    </>
  );
};

export default CompanySummaryPage;
